import React, { useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import AllCountries from "../../components/v4/AllCountries/AllCountries";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import bodySectionBg from "../../images/v4/country/malaysia/images/bodySectionBg.png";
import heroBg from "../../images/v4/country/malaysia/images/heroBg.png";

import malaysia from "../../images/v4/country/malaysia/icons/malaysia.svg";

import bestIcon1 from "../../images/v4/country/india/icons/bestIcon1.svg";
import bestIcon2 from "../../images/v4/country/india/icons/bestIcon2.svg";
import bestIcon3 from "../../images/v4/country/india/icons/bestIcon3.svg";
import bestIcon4 from "../../images/v4/country/india/icons/bestIcon4.svg";
import bestIcon5 from "../../images/v4/country/india/icons/bestIcon5.svg";

import smartIcon1 from "../../images/v4/country/india/icons/smartIcon1.svg";
import smartIcon2 from "../../images/v4/country/india/icons/smartIcon2.svg";
import smartIcon3 from "../../images/v4/country/india/icons/smartIcon3.svg";
import smartIcon4 from "../../images/v4/country/india/icons/smartIcon4.svg";
import smartIcon5 from "../../images/v4/country/india/icons/smartIcon5.svg";
import smartIcon6 from "../../images/v4/country/india/icons/smartIcon6.svg";
import smartIcon7 from "../../images/v4/country/india/icons/smartIcon7.svg";
import smartIcon8 from "../../images/v4/country/india/icons/smartIcon8.svg";
import smartIcon9 from "../../images/v4/country/india/icons/smartIcon9.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/country/malaysia/images/compareItemImg5.png";

import countryBackground from "../../images/v4/country/malaysia/images/countryBackground.png";
import benefitImg from "../../images/v4/country/malaysia/images/benefitImg.png";

import realWorldImg1 from "../../images/v4/country/malaysia/images/realWorldImg1.png";
import realWorldImg2 from "../../images/v4/country/malaysia/images/realWorldImg2.png";
import realWorldImg3 from "../../images/v4/country/malaysia/images/realWorldImg3.png";
import realWorldImg4 from "../../images/v4/country/malaysia/images/realWorldImg4.png";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${heroBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "100px 0 60px",
    "& .countryHighlight": {
      background: "linear-gradient(93deg, #FFB54B -2.84%, #FF1D5A 98.5%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "85%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
        "& .countryLogo": {
          width: "30px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(180deg, #009A99 0%, #1C297E 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  stripSection: {
    backgroundColor: "#e9f4fe",
    // backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  testimonials: {
    background: "#e9f4fe",
  },
  wpFaq: {
    padding: "40px 0",
    background: "#eaffff",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(to right, #011d32 -1%, #00182b 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "50%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0 300px",
      "& .header": {
        width: "100%",
      },
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#ffffff1a",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "16px",
    width: "32%",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  countrySection: {
    padding: "60px 0",
    borderRadius: "40px 40px 0 0",
    backgroundImage: `url(${countryBackground})`,
    backgroundSize: "cover",
    "& .header": {
      width: "60%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .cards": {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      gap: "20px",
      alignItems: "stretch",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        marginTop: "40px",
      },
    },
    "& .card": {
      padding: "32px 24px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "32px",
      backdropFilter: "blur(20px)",
      border: "1px solid #534B69 ",
      width: "48%",
      background:
        "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "0",
    },
  },
  tabsSection: {
    background: "#FFF9F0",
    paddingTop: "280px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "550px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "90%",
    minWidth: "max-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      minWidth: "100%",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "25%",
    minWidth: "max-content",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "20px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    position: "relative",
    top: "5px",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(180deg, #009A99 0%, #1C297E 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  adaptFeatures: {
    backgroundrepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${heroBg})`,
    "& .header": {
      display: "flex",
      width: "55%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .container": {
      paddingBottom: "35px",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
  },
}));

const Malaysia = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question: "Why use a CRM system?",
      answer: (
        <>
          A CRM system helps businesses manage customer relationships more
          effectively, streamline processes, and gain valuable insights,
          ultimately leading to increased sales and customer satisfaction.
        </>
      ),
    },
    {
      question: "How to get CRM for your Malaysian growing business",
      answer: (
        <>
          Getting started with the best CRM software in Malaysia is easier than
          you think. Whether you're a startup or an established business, Pepper
          Cloud makes CRM adoption quick, simple, and effective—so you can start
          managing leads, sales, and customer relationships in no time.
          <ul>
            <li>
              Sign up for a free demo and explore Pepper Cloud CRM with a
              tailored walkthrough.
            </li>
            <li>
              Talk to our local CRM specialists in Malaysia to choose the right
              plan and features.
            </li>
            <li>
              Set up your account easily with no setup fees and a user-friendly
              interface.
            </li>
            <li>
              Customise your CRM to fit your workflows, pipelines, and
              automation needs.
            </li>
            <li>
              Go live and start managing customers efficiently with AI-powered
              tools.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "How to choose the best CRM for your Malaysian business",
      answer: (
        <>
          <ul>
            <li>
              Scalability: Choose a CRM that can grow with your business,
              accommodating increasing customer data and team expansion.
            </li>
            <li>
              Customisation: Look for a CRM that can be tailored to suit your
              specific industry needs and sales workflows.
            </li>
            <li>
              Integration capabilities: Ensure the CRM integrates seamlessly
              with your existing tools and platforms for smooth operations.
            </li>
            <li>
              Local support: Select a CRM provider that offers dedicated local
              support in Malaysia, ensuring quicker response times.
            </li>
            <li>
              Affordable pricing: Ensure the CRM offers a cost-effective
              solution with no hidden fees, ideal for growing businesses.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "Is Pepper Cloud CRM suitable for small businesses in Malaysia?",
      answer: (
        <>
          Yes, Pepper Cloud CRM is highly suitable for small businesses in
          Malaysia. It offers scalable features and pricing, allowing small
          businesses to start with essential functionalities and expand as they
          grow.
        </>
      ),
    },
    {
      question: "Can small businesses in Malaysia benefit from CRM systems?",
      answer: (
        <>
          Absolutely. CRM systems can help small Malaysian businesses improve
          customer relationships, streamline operations, and compete more
          effectively in the market.
        </>
      ),
    },
    {
      question: "What are the common benefits and challenges of CRM?",
      answer: (
        <>
          Common benefits include improved customer relationships, increased
          sales efficiency, and better data management. Challenges may include
          initial setup costs, employee adoption, and data migration.
        </>
      ),
    },
    {
      question: "How does Pepper Cloud CRM cater to the Malaysian market?",
      answer: (
        <>
          Pepper Cloud CRM offers features tailored to Malaysian businesses,
          including WhatsApp integration, local language support, and compliance
          with Malaysian data protection laws.
        </>
      ),
    },
    {
      question:
        "What industries in Malaysia can benefit from Pepper Cloud CRM?",
      answer: (
        <>
          Pepper Cloud CRM is versatile and can benefit various industries
          including retail, manufacturing, professional services, and technology
          companies in Malaysia.
        </>
      ),
    },
    {
      question: "How does Pepper Cloud CRM handle data security?",
      answer: (
        <>
          Pepper Cloud CRM is PDPA approved, ensuring compliance with Malaysian
          data protection regulations and implementing robust security measures
          to protect customer information.
        </>
      ),
    },
    {
      question: "Does Pepper Cloud CRM offer mobile access?",
      answer: (
        <>
          Yes, Pepper Cloud CRM provides mobile access through iOS and Android
          apps, allowing users to manage customer relationships on-the-go.
        </>
      ),
    },
    {
      question:
        "How can Pepper Cloud CRM improve sales processes for Malaysian businesses?",
      answer: (
        <>
          Pepper Cloud CRM offers features like sales pipeline management, lead
          tracking, and AI-powered insights to help Malaysian businesses
          optimise their sales processes and close more deals.
        </>
      ),
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Microsoft Dynamics 365",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM stands out as the premier choice for Malaysian businesses, offering a comprehensive suite of features tailored to the local market. This all-in-one solution combines powerful lead management, AI-driven insights, and robust WhatsApp integration, making it perfectly suited for the Malaysian business landscape. With its user-friendly interface and scalable architecture, Pepper Cloud CRM supports businesses of all sizes in their growth journey.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "AI-powered suite",
          desc: "Leverage chatbots, real-time sales assistance, and automated task management to optimise your business operations.",
        },
        {
          title: "WhatsApp CRM integration",
          desc: "Engage customers directly through Malaysia's most popular messaging platform for effective communication and marketing.",
        },
        {
          title: "Lead management",
          desc: "Capture and track leads with in-built webforms and UTM tracking for personalised marketing campaigns.",
        },
        {
          title: "Omnichannel connectivity",
          desc: "Manage customer interactions across multiple platforms, including voice/video calls, social media, and messaging apps.",
        },
        {
          title: "Automated workflows",
          desc: "Streamline sales and marketing processes with time and event-based automations, including auto lead routing and follow-ups.",
        },
        {
          title: "Customisable dashboards",
          desc: "Create bespoke visualisations and reports to gain deep insights into your business performance.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot offers a comprehensive CRM platform with robust marketing features, making it particularly suited for Malaysian businesses looking to align their sales and marketing efforts. With a user-friendly interface and extensive educational resources, it's an attractive option for companies aiming to enhance their digital presence.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Pipeline builder",
          desc: "Intuitive drag-and-drop pipeline builder for customising sales processes.",
        },
        {
          title: "Marketing automation",
          desc: "Powerful tools for creating and managing marketing campaigns.",
        },
        {
          title: "Free tier",
          desc: "Basic CRM features available at no cost, suitable for small businesses.",
        },
        {
          title: "Integration ecosystem",
          desc: "Wide range of app integrations to extend functionality.",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce is a well-established CRM platform offering a wide range of features for Malaysian businesses. Its extensive customisation options and large marketplace of third-party integrations make it a versatile choice for companies with complex CRM needs.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "AppExchange marketplace",
          desc: "Access to numerous industry-specific apps and integrations.",
        },
        {
          title: "Einstein AI",
          desc: "AI-powered insights and predictions to enhance decision-making.",
        },
        {
          title: "Customisable workflows",
          desc: "Ability to create automated processes tailored to specific business needs.",
        },
        {
          title: "Advanced reporting",
          desc: "Comprehensive analytics tools for tracking business performance.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM provides a cost-effective solution for small to medium-sized Malaysian businesses, offering a good balance of features and affordability. Its user-friendly interface and mobile accessibility make it a practical choice for teams on the go.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Zia AI assistant",
          desc: "AI-powered sales assistant for predictive sales and task automation.",
        },
        {
          title: "Multichannel communication",
          desc: "Tools for managing customer interactions across various platforms.",
        },
        {
          title: "Customisable modules",
          desc: "Ability to tailor the CRM to specific business needs.",
        },
        {
          title: "Gamification features",
          desc: "Motivational tools to boost sales team performance.",
        },
      ],
    },
    {
      title: "Microsoft Dynamics 365",
      desc: "Microsoft Dynamics 365 offers a robust CRM solution that integrates seamlessly with other Microsoft products, making it an attractive option for Malaysian companies already invested in the Microsoft ecosystem. Its AI capabilities and strong focus on customer insights provide valuable tools for businesses looking to enhance their customer relationships.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "LinkedIn integration",
          desc: "Enhanced lead generation and networking capabilities.",
        },
        {
          title: "Power BI integration",
          desc: "Advanced data visualisation and reporting tools.",
        },
        {
          title: "AI-driven insights",
          desc: "Intelligent forecasting and customer behaviour analysis.",
        },
        {
          title: "Industry-specific solutions",
          desc: "Tailored offerings for various sectors relevant to the Malaysian market.",
        },
      ],
    },
  ];

  const bestPractice = [
    {
      icon: smartIcon1,
      alt: "",
      heading: "AI-powered efficiency",
      desc: "Automate tasks, assist sales in real-time, and offer 24/7 support with an AI chatbot, insights, and more to enhance efficiency and service.",
    },
    {
      icon: smartIcon2,
      alt: "",
      heading: "Lead management",
      desc: "Capture, assign, and track leads from multiple channels including WhatsApp, website forms, and Facebook—all in one place.",
    },
    {
      icon: smartIcon3,
      alt: "",
      heading: "Sales pipeline management",
      desc: "Visualise and manage your entire sales process with multi-level pipelines and forecasting tools to help you make smarter decisions, faster.",
    },
    {
      icon: smartIcon4,
      alt: "",
      heading: "Automated workflows",
      desc: "Streamline your sales and marketing with time and event-based workflows. Automate lead routing, follow-ups, and more to boost team productivity.",
    },
    {
      icon: smartIcon5,
      alt: "",
      heading: "WhatsApp CRM",
      desc: "Engage customers on Malaysia’s favourite app with automated replies, WhatsApp flows, and group conversation handling.",
    },
    {
      icon: smartIcon6,
      alt: "",
      heading: "Multichannel communication",
      desc: "Manage conversations from email, WhatsApp, Facebook, Instagram, and Telegram—right inside your CRM.",
    },
    {
      icon: smartIcon7,
      alt: "",
      heading: "Task and activity management",
      desc: "Assign tasks, schedule meetings, and track follow-ups to keep your sales team focused and productive.",
    },
    {
      icon: smartIcon8,
      alt: "",
      heading: "Mobile CRM app",
      desc: "Stay connected on the go with our mobile app—perfect for sales teams working remotely or in the field.",
    },
    {
      icon: smartIcon9,
      alt: "",
      heading: "CRM integrations",
      desc: "Connect Pepper Cloud with your favourite tools like Google Workspace and marketing platforms for a seamless, integrated workflow.",
    },
  ];
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "Personalised tips",
          content: "Send custom workout plans and nutrition tips to members.",
          alt: "Gym CRM",
        },
        {
          heading: "Class updates",
          content:
            "Broadcast class schedules and last-minute availability alerts.",
          alt: "Gym CRM",
        },
        {
          heading: "Motivational content",
          content:
            "Share motivation and success stories to keep members engaged.",
          alt: "Gym CRM",
        },
      ],
      img: realWorldImg1,
      alt: "Gym CRM for Malaysia",
      subtitle:
        "Gyms and fitness centres in Malaysia can leverage Pepper Cloud CRM's WhatsApp broadcast feature to engage and retain members effectively.",
    },
    {
      tabContent: [
        {
          heading: "Follow-ups",
          content:
            "Automate follow-ups and reminders for sales reps' engagement.",
          alt: "Sales CRM",
        },
        {
          heading: "Live updates",
          content: "Share real-time product updates and promos via WhatsApp.",
          alt: "Sales CRM",
        },
        {
          heading: "Performance tracking",
          content:
            "Track sales performance and offer coaching via CRM insights.",
          alt: "Sales CRM",
        },
      ],
      img: realWorldImg2,
      alt: "Sales CRM for Malaysia",
      subtitle:
        "Malaysian sales representatives can benefit greatly from Pepper Cloud CRM's features tailored for sales efficiency.",
    },
    {
      tabContent: [
        {
          heading: "Order updates",
          content:
            "Send automated order updates and shipping notifications to clients.",
          alt: "Manufacturing CRM",
        },
        {
          heading: "Inventory management",
          content: "Manage supplier relationships and inventory via the CRM.",
          alt: "Manufacturing CRM",
        },
        {
          heading: "Product alerts",
          content:
            "Broadcast product updates and offers to distributors and retailers.",
          alt: "Manufacturing CRM",
        },
      ],
      img: realWorldImg3,
      alt: "Manufacturing CRM for Malaysia",
      subtitle:
        "Malaysian manufacturing companies can streamline their operations and improve customer service with Pepper Cloud CRM.",
    },
    {
      tabContent: [
        {
          heading: "Targeted promos",
          content:
            "Send targeted promos and exclusive offers to customer segments.",
          alt: "Retail CRM",
        },
        {
          heading: "Sales alerts",
          content: "Broadcast new arrivals and flash sales to boost sales.",
          alt: "Retail CRM",
        },
        {
          heading: "Loyalty rewards",
          content: "Manage loyalty programs and send rewards via WhatsApp.",
          alt: "Retail CRM",
        },
      ],
      img: realWorldImg4,
      alt: "Retail CRM for Malaysia",
      subtitle:
        "Pepper Cloud CRM can help Malaysian retailers enhance customer engagement and boost sales through personalised marketing.",
    },
  ];
  const cards = [
    {
      heading: "What is Malaysian CRM software?",
      content:
        "Malaysian CRM software is a customer relationship management system designed to help businesses in Malaysia manage their sales, marketing, and customer support processes efficiently - all within a single platform that understands local needs.",
    },
    {
      heading: "Why Malaysian businesses need a CRM?",
      content:
        "A CRM helps businesses build strong customer relationships, improve communication, and streamline operations. In Malaysia’s competitive landscape, having a CRM system in place can give you the edge to grow faster and serve better.",
    },
  ];
  const adaptList = [
    {
      pointer: "Unified CRM Solution",
      desc: "Pepper Cloud combines lead management and sales automation into one unified platform—no need for multiple tools.",
      img: bestIcon1,
    },
    {
      pointer: "Scalable for Any Business",
      desc: "Whether you're a startup, SME or enterprise, our CRM is tailored to suit your business stage and industry.",
      img: bestIcon2,
    },
    {
      pointer: "Cost-Effective Pricing",
      desc: "Transparent and cost-effective plans with zero setup charges—built to support Malaysian SMEs and startups.",
      img: bestIcon3,
    },
    {
      pointer: "Local Support 24/7",
      desc: "Get round-the-clock help from our team who understands the Malaysian market and speaks your language.",
      img: bestIcon4,
    },
    {
      pointer: "Customizable CRM",
      desc: "Tailor the CRM with flexible workflows, custom fields, and pipeline stages to match your unique sales process.",
      img: bestIcon5,
    },
  ];
  const pointers = [
    "Stay organised by tracking all your leads, deals, and customer interactions in one place.",
    "Boost team productivity with automated follow-ups and reminders.",
    "Make smarter decisions with real-time insights and sales reports.",
    "Improve customer relationships through personalised communication across channels.",
  ];
  return (
    <main>
      <SEO
        title={"Best CRM Software in Malaysia | Pepper Cloud"}
        pathname={
          "https://peppercloud.com/country/best-crm-software-in-malaysia/"
        }
        keywords="best crm software malaysia,crm software malaysia, crm system in malaysia, crm system malaysia, best crm malaysia"
        description={
          "Boost your growth with the best CRM software in Malaysia. Pepper Cloud CRM helps you manage leads, automate tasks, and engage customers easily."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Why use a CRM system?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A CRM system helps businesses manage customer relationships more effectively, streamline processes, and gain valuable insights, ultimately leading to increased sales and customer satisfaction.",
                },
              },
              {
                "@type": "Question",
                name: "How to get CRM for your Malaysian growing business",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Getting started with the best CRM software in Malaysia is easier than you think. Whether you're a startup or an established business, Pepper Cloud makes CRM adoption quick, simple, and effective—so you can start managing leads, sales, and customer relationships in no time. Sign up for a free demo and explore Pepper Cloud CRM with a tailored walkthrough. Talk to our local CRM specialists in Malaysia to choose the right plan and features. Set up your account easily with no setup fees and a user-friendly interface. Customise your CRM to fit your workflows, pipelines, and automation needs. Go live and start managing customers efficiently with AI-powered tools.",
                },
              },
              {
                "@type": "Question",
                name: "How to choose the best CRM for your Malaysian business",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Scalability: Choose a CRM that can grow with your business, accommodating increasing customer data and team expansion. Customisation: Look for a CRM that can be tailored to suit your specific industry needs and sales workflows. Integration capabilities: Ensure the CRM integrates seamlessly with your existing tools and platforms for smooth operations. Local support: Select a CRM provider that offers dedicated local support in Malaysia, ensuring quicker response times. Affordable pricing: Ensure the CRM offers a cost-effective solution with no hidden fees, ideal for growing businesses.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM suitable for small businesses in Malaysia?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM is highly suitable for small businesses in Malaysia. It offers scalable features and pricing, allowing small businesses to start with essential functionalities and expand as they grow.",
                },
              },
              {
                "@type": "Question",
                name: "Can small businesses in Malaysia benefit from CRM systems?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. CRM systems can help small Malaysian businesses improve customer relationships, streamline operations, and compete more effectively in the market.",
                },
              },
              {
                "@type": "Question",
                name: "What are the common benefits and challenges of CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Common benefits include improved customer relationships, increased sales efficiency, and better data management. Challenges may include initial setup costs, employee adoption, and data migration.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud CRM cater to the Malaysian market?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM offers features tailored to Malaysian businesses, including WhatsApp integration, local language support, and compliance with Malaysian data protection laws.",
                },
              },
              {
                "@type": "Question",
                name: "What industries in Malaysia can benefit from Pepper Cloud CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is versatile and can benefit various industries including retail, manufacturing, professional services, and technology companies in Malaysia.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud CRM handle data security?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is PDPA approved, ensuring compliance with Malaysian data protection regulations and implementing robust security measures to protect customer information.",
                },
              },
              {
                "@type": "Question",
                name: "Does Pepper Cloud CRM offer mobile access?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM provides mobile access through iOS and Android apps, allowing users to manage customer relationships on-the-go.",
                },
              },
              {
                "@type": "Question",
                name: "How can Pepper Cloud CRM improve sales processes for Malaysian businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM offers features like sales pipeline management, lead tracking, and AI-powered insights to help Malaysian businesses optimise their sales processes and close more deals.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72 color-black1"
            >
              Drive growth with the best CRM Software in{" "}
              <img className="countryLogo" src={malaysia} alt="malaysia" />{" "}
              <span className="countryHighlight">Malaysia</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Revolutionise your business operations with Pepper Cloud CRM, the
              ultimate all-in-one CRM software solution for Malaysian companies
              seeking to enhance customer relationships, streamline processes,
              and drive growth.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  AI-powered automation
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  WhatsApp integration
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Omnichannel communication
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link
                to="/contact/"
                className="primaryButton font-20 font-wix-medium font-white"
              >
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.countrySection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              A quick guide about best CRM software Malaysia
            </motion.h2>
          </div>
          <div className="cards">
            {cards.map((card) => (
              <div className="card">
                <p className="font-24 font-wix-semibold font-white">
                  {card.heading}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {card.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why Pepper Cloud is the best CRM software system in Malaysia
            </motion.h2>
          </div>
        </div>
        <Swiper
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={true}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  alt={point.pointer}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Everything you need to sell smarter, faster, and better
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-white">
                  {practice.heading}
                </p>
                <p
                  className="font-wix-medium font-16"
                  style={{ color: "#E9F4FE" }}
                >
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          {/* <TruestedSection background={true} /> */}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Benefits of using a CRM tool for your Malaysian growing business
              </p>
              <div className={classes.pointers}>
                {pointers.map((pointer) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {pointer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benefitImg}
                alt={
                  "Benefits of using a CRM tool for your Malaysian growing business"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Applications and use cases of Malaysia CRM software
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                 Fitness and wellness
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Sales team management
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Manufacturing
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Retail
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.benfitListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.benfitIcon}
                              alt={item.alt}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-16 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 best CRM software in Malaysia in 2025
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TruestedSection />
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <AllCountries />
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#eaffff"}
          heading={"FAQs - Best CRM software in Malaysia"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Streamline your sales, amplify your impact!
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Malaysia;
